import { render, staticRenderFns } from "./flow_arrow.vue?vue&type=template&id=741392cf&scoped=true"
import script from "./flow_arrow.vue?vue&type=script&lang=js"
export * from "./flow_arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741392cf",
  null
  
)

export default component.exports